module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/trash-e43a0a3451c0aa2fc8bd577d1a869317.svg";